import { PRE_SIGN_PARAMS } from '@/shared/config';

export const urlHasPresignParams = (url: string | null): boolean =>
  Boolean(
    url &&
      url.includes(PRE_SIGN_PARAMS.signature) &&
      url.includes(PRE_SIGN_PARAMS.clientKeyID) &&
      url.includes(PRE_SIGN_PARAMS.timestampUnixMilli) &&
      url.includes(PRE_SIGN_PARAMS.userID),
  );
